import { useState } from 'react';
import { ClientFlagsProvider } from '@sdk/session/ClientFlagsContext';
import gettext from '@sdk/lang/gettext';
import useAuth from '@sdk/authentication/useAuth';
import { RoleType } from '@sdk/authentication/types';

import { useShouldShow } from '@web/common/hooks/useShouldShow';
import FeatureAnnouncementModal from '@web/components/FeatureAnnouncementModal/FeatureAnnouncementModal';

import { Image } from './EducationalModal.styles';

type Props = {
  onButtonClick: () => void;
};

const Inner = ({ onButtonClick }: Props) => {
  const { currentUser } = useAuth();
  const { dontShowAgain, shouldShow } = useShouldShow(
    'projectedSalesImportEducationalModal',
    currentUser,
    { delayInMinutes: 60 * 24, roles: [RoleType.manager, RoleType.admin] }
  );

  const [isVisible, setIsVisible] = useState(shouldShow());
  const close = () => {
    dontShowAgain();
    setIsVisible(false);
  };
  const handleButtonClick = () => {
    close();
    onButtonClick();
  };
  const handleDismiss = () => {
    close();
  };

  return (
    <FeatureAnnouncementModal
      isVisible={isVisible}
      image={<Image />}
      dismiss={handleDismiss}
      title={gettext('Psst! Sync forecasted revenue directly from Toast!')}
      description={gettext(
        'Now you are able to sync your projected net sales directly from Toast to help manage your labor costs and staffing needs, and build better schedules.'
      )}
      buttonText={gettext('Try it now')}
      onButtonClick={handleButtonClick}
      bannerBgColor="transparent"
      isBeta={true}
    />
  );
};

export const ProjectedSalesImportEducationalModal = (props: Props) => (
  <ClientFlagsProvider>
    <Inner {...props} />
  </ClientFlagsProvider>
);
